import {
  Component,
  computed,
  EventEmitter,
  input,
  InputSignal,
  OnDestroy,
  OnInit,
  Output,
  Signal,
  signal,
  WritableSignal
} from '@angular/core';
import { PaymentCommonService } from '../../services/payment.common.service';
import { PaymentBaseAllBaseReadPaymentAllPaymentRead } from '../../openapi';
import { AlertComponent, AlertType } from '../alert/alert.component';
import { CommonModule } from '@angular/common';
import { PaymentStatus, PaymentStatusPipe } from '../../pipes/payment-status.pipe';
import { firstValueFrom, Subscription, switchMap, tap, timer } from 'rxjs';

@Component({
  selector: 'app-payment-status-checker',
  standalone: true,
  imports: [
    AlertComponent,
    CommonModule,
    PaymentStatusPipe
  ],
  templateUrl: './payment-status-checker.component.html'
})
export class PaymentStatusCheckerComponent implements OnInit, OnDestroy {

  public closableAlert: InputSignal<boolean> = input(false);

  public paymentToken: InputSignal<string | undefined> = input();

  public canDownload: InputSignal<boolean> = input(false);

  private timerSubscription: Subscription | undefined;

  public showAlert = true;

  public paymentInfo: WritableSignal<PaymentBaseAllBaseReadPaymentAllPaymentRead> = signal({});

  public alertType: Signal<AlertType> = computed(() => {
    const status: PaymentStatus = this.paymentInfo()?.status || 'no-info';
    switch (true) {
      case status === 'completed': {
        return 'success';
      }
      case status === 'failed': {
        return 'danger';
      }
      case status === 'cancelled': {
        return 'danger';
      }
      case status === 'expired': {
        return 'danger';
      }
      default: {
        return 'info';
      }
    }
  });

  @Output()
  public completed = new EventEmitter<boolean>();

  constructor(
    private paymentCommonService: PaymentCommonService
  ) {
  }

  public download(e: Event, id: string): void {
    e.preventDefault();
    e.stopPropagation();
    firstValueFrom(this.paymentCommonService.downloadConfirmation(id)).then();
  }

  public ngOnInit(): void {
    if (this.paymentToken()) {
      this.timerSubscription = timer(0, 10000).pipe(
        switchMap(() => this.paymentCommonService.loadPaymentInfo(this.paymentToken() || '')),
        tap({
          next: paymentInfo => {
            this.paymentInfo.set(paymentInfo || {});
            if (['completed', 'failed', 'cancelled', 'expired'].includes(paymentInfo?.status || '')) {
              this.completed.emit(true);
              this.timerSubscription?.unsubscribe();
            }
          },
          error: () => {
            this.paymentInfo.set({
              status: 'no-info'
            });
            this.completed.emit(true);
            this.timerSubscription?.unsubscribe();
          }
        })
      ).subscribe();
    }
  }

  public ngOnDestroy(): void {
    this.timerSubscription?.unsubscribe();
  }
}
